import {
  DialogContent,
  Dialog,
  DialogProps,
  DialogActions,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { styled } from '@mui/styles';

export const PmiDialog = styled((props: DialogProps) => <Dialog {...props} />)((props) => ({
  '& .MuiDialog-paper': props.fullScreen
    ? {
        minWidth: 'unset',
        maxWidth: '100%',
      }
    : {
        minWidth: '25rem',
        maxWidth: '30rem',
      },
}));

interface ModalInfoCertificationProps {
  open: boolean;
  onClose: (open: boolean) => void;
  amountCertifate?: string;
  title?: string;
}

const ModalInfoCertification = ({
  open,
  onClose,
  title,
}: // amountCertifate,
ModalInfoCertificationProps): React.ReactElement => {
  const nameCertificate = title;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return (
    <PmiDialog
      open={open}
      aria-labelledby="alert-dialog-title"
      fullScreen={fullScreen}
      aria-describedby="alert-dialog-description"
    >
      <DialogContent style={{ padding: '30px 24px' }}>
        Emesso certificato <b>{nameCertificate}</b>.
      </DialogContent>
      <DialogActions>
        <PmiButton
          variant="outlined"
          color="cdmBrandThird"
          type="button"
          onClick={() => onClose(false)}
        >
          Chiudi
        </PmiButton>
      </DialogActions>
    </PmiDialog>
  );
};

ModalInfoCertification.displayName = 'Modal info certification';

export default ModalInfoCertification;
